export default "<app-menu-bar-sale></app-menu-bar-sale>"